var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBannerArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pu3os02m6a",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2916"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2384"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#pu3os02m6a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4111",
    d: "M18 0a18 18 0 1 0 18 18A18 18 0 0 0 18 0z",
    transform: "translate(15 14)",
    style: {
      fill: "#fff",
      opacity: 0.805
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 818",
    d: "m12037.735-580.38-7.7-7.126 7.7-7.7",
    transform: "translate(-12000.895 619.513)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 3
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBannerArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-bannerArrowLeft.5eb1240776e8092f4ce04507a4f4a582.svg";